import { ShadowChargingStationStatus } from './brokerChargingStationShadow';
import { ChargingStationStatus } from './chargingStationModel';

export function getCSStatus(
  chargingStationStatus?: ShadowChargingStationStatus
): ChargingStationStatus {
  return chargingStationStatus
    ? chargingStationShadowStatusMap[chargingStationStatus]
    : 'undefined';
}

const chargingStationShadowStatusMap: Record<
  ShadowChargingStationStatus,
  ChargingStationStatus
> = {
  AVAILABLE: 'available',
  CHARGING: 'charging',
  FAULTED: 'faulted',
  FINISHING: 'finishing',
  OCCUPIED: 'occupied',
  PREPARING: 'preparing',
  RESERVED: 'reserved',
  SUSPENDED_EV: 'suspendedEV',
  SUSPENDED_EVSE: 'suspendedEVSE',
  UNAVAILABLE: 'unavailable',
  UNDEFINED: 'undefined',
};
